/**
 * TariffSection — каркас блока тарифа (Соло / Клиника): белая карточка,
 * шапка (иконка + заголовок/подзаголовок + ярлык версии + действие) и тело.
 * Убирает повтор между SoloCard и ClinicCard.
 */

import type {ReactNode} from 'react';

type TariffSectionProps = {
  icon: ReactNode;
  /** Классы подложки иконки (фон + цвет). */
  iconClassName: string;
  title: string;
  subtitle: string;
  /** Ярлык версии; не задан — секция без версий (напр. триал-функции) */
  version?: string;
  action?: ReactNode;
  children: ReactNode;
};

export const TariffSection = ({
  icon,
  iconClassName,
  title,
  subtitle,
  version,
  action,
  children,
}: TariffSectionProps) => (
  <div className="rounded-2xl border border-skr-line bg-card px-6 py-[22px]">
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-center gap-[13px]">
        <div className={`grid size-11 place-items-center rounded-xl ${iconClassName}`}>{icon}</div>
        <div>
          <div className="text-base font-bold -tracking-[.01em]">{title}</div>
          <div className="mt-0.5 text-[12.5px] text-muted-foreground">{subtitle}</div>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2.5">
        {version !== undefined && (
          <span className="font-mono text-[11.5px] text-muted-foreground">{version}</span>
        )}
        {action}
      </div>
    </div>
    {children}
  </div>
);
